// @flow
import { apiError, get, patch, post } from 'util/api'
import type { User } from 'types'
import type { SearchCriteria } from 'types/user'
import { getReferrerData } from 'util/referrer'

export type CredentialCheckResponse = {
  exists: boolean,
  hasPassword: boolean,
}

type CreateData = $Shape<User> & {
  taskProfile?: { isLicensed: boolean },
  signUpSource: string,
  parentTosAgreed?: true,
  directorTosAgreed?: true,
  searchCriteria?: $Shape<SearchCriteria> | null,
  family?: {},
  isLicensed?: boolean,
  postalCode?: string,
  userType?: 'parent' | 'director',
}

type UpdateData = $Shape<User> & {
  parentTosAgreed?: true,
  directorTosAgreed?: true,
  searchCriteria?: $Shape<SearchCriteria> | null,
}

export function fetch(id: number): Promise<User> {
  return get(`/api/users/${id}`).then(response => response.json.user)
}

export function create(user: $Shape<CreateData>): Promise<User> {
  const params = {
    referrer: getReferrerData(),
    ...user,
  }

  return post('/api/users', { user: params })
    .then(response => response.json.user)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function update(id: number, user: $Shape<UpdateData>): Promise<User> {
  return patch(`/api/users/${id}`, { user })
    .then(response => response.json.user)
    .catch(response => {
      throw apiError(response.json)
    })
}

export function credentialCheck(email: string): Promise<CredentialCheckResponse> {
  return get('/api/users/credential-check', { email }).then(response => response.json.user)
}
